module.exports = __webpack_public_path__ + "static/media/closeWhite.18dbd31e.svg";